module.exports = __webpack_public_path__ + "ch.svg?8200f4a1eda7bf2a86b2135b89493124";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ch.svg
// module id = 969
// module chunks = 27